import React from "react";

import { ComponentPrice } from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/components_pb";

import { getComponentPriceLabel } from "helpers/get-component-price-label";

interface CurrencyFormatterProps {
  componentPrice: ComponentPrice;
  unitLabel: string;
}

const ComponentPriceInfo = ({
  unitLabel,
  componentPrice,
}: CurrencyFormatterProps) => {
  return <>{getComponentPriceLabel(componentPrice, unitLabel)}</>;
};

export default ComponentPriceInfo;
